import { render, staticRenderFns } from "./HospitalDiaComponente.vue?vue&type=template&id=105837e0&scoped=true"
import script from "./HospitalDiaComponente.vue?vue&type=script&lang=js"
export * from "./HospitalDiaComponente.vue?vue&type=script&lang=js"
import style0 from "./HospitalDiaComponente.vue?vue&type=style&index=0&id=105837e0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "105837e0",
  null
  
)

export default component.exports